import { Form, FormInstance, FormProps } from 'antd';
import * as React from 'react';
import useFormBuilder from '../../hooks/useFormBuilder';

interface CustomFormProps extends FormProps {
  onValuesChange?: (changedValues: any, values: any) => boolean | void;
}

interface FCProps {
  form: FormInstance;

  formName: string;

  formProps?: CustomFormProps;

  beforeValueSet?: (values: any) => any;
}

const SessionForm: React.FC<React.PropsWithChildren<FCProps>> = ({
  children,
  form,
  formName,
  formProps,
  beforeValueSet
}) => {
  const formManager = useFormBuilder({
    instance: form,
    name: formName,
    beforeValueSet
  });

  return (
    <Form
      {...formProps}
      form={form}
      onValuesChange={(changedValues, values) => {
        let formModel = formManager.getFormModel(formName);

        let validated;
        if (formProps?.onValuesChange) {
          validated = formProps.onValuesChange(changedValues, values);
        }

        if (validated === false) {
          return;
        }

        Object.keys(changedValues).forEach((key) => {
          formModel.updateFormData({
            ...values,
            [key]: changedValues[key]
          });
        });
      }}>
      {children}
    </Form>
  );
};

export default SessionForm;
